import BackButtonToolbar from "features/BackButtonToolbar";
import {
  ArrayInput,
  Create,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  useNotify,
  useStore,
} from "react-admin";
import dataProvider from "server/dataProvider";
import { Grid } from "@mui/material";
import { settings } from "app";
import { useNavigate } from "react-router";
import { activityRequests } from "api/activityApi";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";
import { CAPACITY_KEY } from "./List";

const CreateForeignLanguageCapacity = () => {
  const notify = useNotify();
  const navigate = useNavigate();
  const notifyError = useNotifyError();

  // Read-only consumer of the committed academic year from the capacity list.
  const [filters] = useStore(CAPACITY_KEY, null);
  const academicYearId = filters?.academicYearId ?? null;

  const initialValues = {
    capacities: [
      {
        academicYearId,
        foreignLanguageId: null,
        studentsCapacity: null,
      },
    ],
  };

  const handleSave = async values => {
    try {
      await dataProvider.customRequest(`activity/foreign-languages/capacities`, values, "POST");
      notify("Записът е създаден", { type: "success" });
      navigate(-1);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <Create
      title="Създаване капацитет за чужди езици"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm
        onSubmit={handleSave}
        defaultValues={initialValues}
      >
        <ArrayInput
          source="capacities"
          label=""
        >
          <SimpleFormIterator sx={settings.style.iteratorWithoutGap}>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                xs={12}
                md={4}
              >
                <ReferenceInput
                  source="academicYearId"
                  reference={studentRequests.getAcademicYearsSelect()}
                >
                  <SelectInput
                    optionText="name"
                    label="Академична година"
                    readOnly={!!academicYearId}
                    validate={[required()]}
                  />
                </ReferenceInput>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
              >
                <ReferenceInput
                  reference={activityRequests.getActivityForeignLanguagesSelect()}
                  source="foreignLanguageId"
                >
                  <SelectInput
                    label="Избор на чужд език"
                    optionText="name"
                    validate={[required()]}
                  />
                </ReferenceInput>
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
              >
                <NumberInput
                  source="studentsCapacity"
                  label="Капацитет студенти"
                />
              </Grid>
            </Grid>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default CreateForeignLanguageCapacity;
